import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { NgClass } from '@angular/common';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';

import { SnackBarData } from '@app/types/snack-bar.types';

@Component({
  selector: 'app-snack-bar-item',
  imports: [NgClass],
  templateUrl: './snack-bar-item.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './snack-bar-item.component.scss'
})
export class SnackBarItemComponent {
  private snackBarRef = inject<MatSnackBarRef<SnackBarItemComponent>>(MatSnackBarRef);
  data = inject<SnackBarData>(MAT_SNACK_BAR_DATA);

  dismiss(): void {
    this.snackBarRef.dismiss();
  }
}
